import { inject, injectable } from "@launchtray/tsyringe-async";
import { PromiseCompletionSource, Viewable } from "scene-manager";
import { InjectableInterfaces } from "../../../composition/InjectableInterfaces";
import { ICanvasScaler } from "../../../../canvas/ICanvasScaler";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { PauseResourcesPackage } from "./resources/PauseResourcesPackage";
import { PauseView } from "./views/PauseView";
import { PauseSceneResult } from "./PauseSceneResult";
import { SettingsModel } from "../../../common/models/SettingsModel";
import { SettingsController } from "../../../common/controllers/SettingsController";

@injectable()
export class PauseScene extends Viewable<PauseSceneResult> {
    public constructor(
        commonResources: CommonResourcesPackage,
        pauseResources: PauseResourcesPackage,
        settingsController: SettingsController,
        settingsModel: SettingsModel,
        @inject(InjectableInterfaces.ICanvasScaler)
        canvasScaler: ICanvasScaler
    ) {
        super();
        const pcs = new PromiseCompletionSource<PauseSceneResult>();
        this.view = new PauseView(
            commonResources,
            pauseResources,
            settingsModel,
            settingsController,
            canvasScaler,
            pcs
        );
        pcs.result.then(
            (result: PauseSceneResult) => this.operationControls.complete(result),
            (reason: unknown) => this.operationControls.error(reason)
        );
    }
}
